import { render, staticRenderFns } from "./GameIframe.vue?vue&type=template&id=10e8f488&"
import script from "./GameIframe.vue?vue&type=script&lang=js&"
export * from "./GameIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports